<template>
  <div class="occupat-choice">
    <div class="occupat-choice-title">
      <div>多领域职业选择，个人发展快人一步</div>
      <p>全流程快捷学习，培养复合型人才</p>
    </div>
    <div class="occupat-choice-content"></div>
  </div>
</template>

<script>
export default {
  name: "occupatChoice"
}
</script>

<style lang="scss" scoped>
  .occupat-choice {
    min-width: 1200px;
    width: 1200px;
    background-color: #fff;
    padding-bottom: 76px;
    margin: 0px auto;
    .occupat-choice-title {
      min-width: 1200px;
      background-color: #fff;
      
      width: 100%;
      padding-top: 76px;
      div {
        font-size: 32px;
        font-weight: 600;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family:  "PingFangSC", "PingFangSC-Regular";
        text-align: center;
        color: #19232B;
        line-height: 47px;
      }
      p {
        font-family:"PingFangSC", "PingFangSC-Semibold";
        text-align: center;
        color: #616A72;
        // line-height: 42px;
        font-size: 18px;
        margin-top: 20px;
      }
    }
    .occupat-choice-content {
      margin: 0px auto;
      margin-top: 76px;
      // margin-bottom: 76px;
      background: url("../pythonImg/domain1.png") no-repeat;
      background-size: 100% 100%;
      width: 1200px;
      min-width: 1200px;
      height: 728px;
    }
  }
</style>